import { utils } from '@febos-io/design';

import meta from '../../package.json';

export function t(key) {
  return utils.t(key, meta.name);
}
